import { useState, useEffect, useMemo } from "react";
import { Box, Divider } from "@mui/material";
import DesignStudy from "./DesignStudy";
import PrepareBatch from "./PrepareBatch";
import Audit from "./AuditBatch";
import { GlobalTabCollection, StyledTab } from "../../pages/styles";
import { useUser } from "../../context/UserContext";
import AuthGate from "../../routing/components/AuthGate";

enum BlendsTab {
  DesignStudy = "DesignStudy",
  PrepareBatch = "PrepareBatch",
  Audit = "Audit",
}

const tabConfig = {
  [BlendsTab.DesignStudy]: {
    label: "Design Study",
    Component: DesignStudy,
    requiresAuth: true,
  },
  [BlendsTab.PrepareBatch]: {
    label: "Prepare Batch",
    Component: PrepareBatch,
    requiresAuth: false,
  },
  [BlendsTab.Audit]: {
    label: "Audit Batch",
    Component: Audit,
    requiresAuth: true,
  },
};

const Blends = () => {
  const { isGuestUser } = useUser();

  const availableTabs = useMemo(() => {
    return Object.values(BlendsTab).filter((tab) => !tabConfig[tab].requiresAuth || !isGuestUser);
  }, [isGuestUser]);

  const [activeTab, setActiveTab] = useState<BlendsTab>(availableTabs[0]);

  useEffect(() => {
    if (!availableTabs.includes(activeTab)) {
      setActiveTab(availableTabs[0]);
    }
  }, [availableTabs, activeTab]);

  const activeTabIndex = availableTabs.indexOf(activeTab);

  const handleChange = (_event: React.SyntheticEvent, newIndex: number) => {
    setActiveTab(availableTabs[newIndex]);
  };

  const { Component: ActiveComponent, requiresAuth } = tabConfig[activeTab];

  return (
    <Box paddingBottom={4}>
      <span className="pageheader">Blends</span>
      <Divider className="dividerbar" />
      <div>
        <Box sx={{ bgcolor: "#fff", pt: 3, pb: 1 }}>
          <GlobalTabCollection
            value={activeTabIndex}
            onChange={handleChange}
            aria-label="blends tabs">
            {availableTabs.map((tab) => (
              <StyledTab key={tab} label={tabConfig[tab].label} />
            ))}
          </GlobalTabCollection>
        </Box>

        {requiresAuth ? (
          <AuthGate>
            <ActiveComponent />
          </AuthGate>
        ) : (
          <ActiveComponent />
        )}
      </div>
    </Box>
  );
};

export default Blends;
